export const aiModels = {
    deepseek:"deepseek",
    openai:"openai"
}